"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSelectorCtrl = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
class StatusSelectorCtrl {
    constructor() {
        this.loading = true;
    }
    get loadingStatuses() {
        return this.loading;
    }
    get statusOptions() {
        this.loading = true;
        const options = [];
        const allCollectionStatuses = [];
        for (const summary of page_state_1.CurrentState.Tag.collections) {
            const collectionStatuses = [];
            const formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
            if (formSummary != null && formSummary.metadata != null && formSummary.metadata.status != null) {
                const form = store_1.AppStore.Form.get(formSummary.revision);
                if (form != null && form !== undefined && form.metadata != null) {
                    for (const value of form.metadata.getStatusField().options.values) {
                        const values = this.getAllValuesFrom(value);
                        values.forEach(option => {
                            options.push({ key: option, value: option });
                            collectionStatuses.push(option);
                        });
                    }
                    allCollectionStatuses.push({
                        collectionId: summary.objectId,
                        statuses: collectionStatuses,
                        statusFieldId: form.metadata.statusFieldId
                    });
                }
            }
        }
        this.allStatuses = allCollectionStatuses;
        this.loading = false;
        return this.uniqueOptions(options);
    }
    selectStatus(status) {
        this.selectedStatus = status;
    }
    getAllValuesFrom(value) {
        const values = [];
        if (value.options && value.options.values) {
            for (const option of value.options.values) {
                if (option.options && option.options.values) {
                    for (const optionThirdLevel of option.options.values) {
                        if (optionThirdLevel.value) {
                            values.push(value.value + ' > ' + option.value + ' > ' + optionThirdLevel.value);
                        }
                    }
                }
                else {
                    if (option.value) {
                        values.push(value.value + ' > ' + option.value);
                    }
                }
            }
        }
        else {
            if (value.value) {
                values.push(value.value);
            }
        }
        return values;
    }
    uniqueOptions(options) {
        var seen = {};
        return options.filter(function (item) {
            return seen.hasOwnProperty(item.value) ? false : (seen[item.value] = true);
        });
    }
}
exports.StatusSelectorCtrl = StatusSelectorCtrl;
tslib_1.__decorate([
    mobx_1.observable
], StatusSelectorCtrl.prototype, "selectedStatus", void 0);
tslib_1.__decorate([
    mobx_1.computed
], StatusSelectorCtrl.prototype, "loadingStatuses", null);
tslib_1.__decorate([
    mobx_1.computed
], StatusSelectorCtrl.prototype, "statusOptions", null);
tslib_1.__decorate([
    mobx_1.action
], StatusSelectorCtrl.prototype, "selectStatus", null);
//# sourceMappingURL=status.selector.ctrl.js.map